export default __webpack_public_path__ + "static/media/orchid_tracking-yellow.b8f85998.svg";